import {
  Injectable
} from '@angular/core';

import {
  HttpClient
} from '@angular/common/http';

import {
  Observable
} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TransactionActionService {

  constructor(
    private http: HttpClient
  ) {}

  execute(
    action: any,
    payload: any
  ): Observable<any> {

    const method =
      (action.method || 'POST')
      .toUpperCase();

    switch (method) {

      case 'GET':
        return this.http.get(action.api);

      case 'PUT':
        return this.http.put(
          action.api,
          payload
        );

      case 'DELETE':
        return this.http.delete(
          action.api
        );

      default:
        return this.http.post(
          action.api,
          payload
        );
    }
  }
}